import { createFileRoute } from "@tanstack/react-router";
import { Spinner } from "~/components/ui/spinner";
import { ActivityBookingCard } from "~/features/activities-booking/components/activity-booking-card";
import { useActivity } from "~/features/tour-activities/api/get-activity";
import { TourActivityHeader } from "~/features/tour-activities/components/tour-activity-header";
import { TourActivityHero } from "~/features/tour-activities/components/tour-activity-hero";
import { TourActivityItinerary } from "~/features/tour-activities/components/tour-activity-itinerary";
import { TourActivityKnowBeforeYouGo } from "~/features/tour-activities/components/tour-activity-know-before-you-go";

export const Route = createFileRoute("/activities/$id/")({
  component: RouteComponent,
  validateSearch: (search) => ({
    startRatePax: Number(search.startRatePax) || 0,
    startRate: Number(search.startRate) || 0,
  }),
});

function RouteComponent() {
  const { id } = Route.useParams();
  const search = Route.useSearch();
  const { data, isPending, error } = useActivity({ id: id });

  if (isPending) {
    return (
      <div className="ekv:w-full ekv:max-w-4xl ekv:mx-auto ekv:py-8 p-4">
        <Spinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="ekv:w-full ekv:max-w-4xl ekv:mx-auto ekv:py-8 p-4">
        Error loading package details: {error.message}
      </div>
    );
  }

  return (
    <div className="ekv:w-full ekv:max-w-4xl ekv:mx-auto ekv:py-8 ekv:p-4">
      <TourActivityHero
        gallery={data.itineraries.itinerary_gallery}
        activityName={data.name}
      />

      {/* Main Content Grid */}
      {/* <div className="ekv:grid ekv:grid-cols-1 ekv:lg:grid-cols-3 ekv:gap-8 ekv:mb-8"> */}
      {/* Left Column - Main Content */}
      <div className="ekv:lg:col-span-2 ekv:space-y-6">
        {/* Title and Metadata */}
        <TourActivityHeader
          name={data.name}
          hours={data.hour}
          departureCity={data.departure_city}
          type={data.type}
        />

        <ActivityBookingCard
          activityId={data.id}
          startRatePax={search.startRatePax}
          startRate={search.startRate}
        />

        {/* Overview Section */}
        {data.overview && (
          <div>
            <h2 className="ekv:text-2xl ekv:font-bold ekv:mb-4">Overview</h2>
            <div
              className="ekv:prose ekv:max-w-none ekv:text-muted-foreground"
              dangerouslySetInnerHTML={{ __html: data.overview }}
            />
          </div>
        )}

        {/* Highlights Section */}
        {data.highlight && (
          <div>
            <h2 className="ekv:text-2xl ekv:font-bold ekv:mb-4">Highlight</h2>
            <div
              className="ekv:prose ekv:max-w-none ekv:text-muted-foreground"
              dangerouslySetInnerHTML={{ __html: data.highlight }}
            />
          </div>
        )}

        {/* Itinerary Section */}
        <TourActivityItinerary
          itineraries={data.itineraries.itinerary_description}
        />

        {/* Includes/Excludes Section */}
        {data.itineraries.itinerary_include.length > 0 && (
          <div>
            {data.itineraries.itinerary_include[0].include && (
              <div className="ekv:mb-6">
                <h2 className="ekv:text-2xl ekv:font-bold ekv:mb-4">
                  Includes
                </h2>
                <div
                  className="ekv:prose ekv:prose-sm ekv:max-w-none ekv:text-muted-foreground [&>ul]:ekv:list-disc [&>ul]:ekv:pl-5 [&>ul]:ekv:space-y-2"
                  dangerouslySetInnerHTML={{
                    __html: data.itineraries.itinerary_include[0].include,
                  }}
                />
              </div>
            )}
            {data.itineraries.itinerary_include[0].exclude && (
              <div>
                <h2 className="ekv:text-2xl ekv:font-bold ekv:mb-4">
                  Excludes
                </h2>
                <div
                  className="ekv:prose ekv:prose-sm ekv:max-w-none ekv:text-muted-foreground [&>ul]:ekv:list-disc [&>ul]:ekv:pl-5 [&>ul]:ekv:space-y-2"
                  dangerouslySetInnerHTML={{
                    __html: data.itineraries.itinerary_include[0].exclude,
                  }}
                />
              </div>
            )}
          </div>
        )}

        {/* Know before you go Section */}
        {(data.child_policy_description ||
          data.cancellation_description ||
          data.trip_note) && (
          <TourActivityKnowBeforeYouGo
            childPolicyDescription={data.child_policy_description}
            departureCity={data.departure_city}
            arrivalCity={data.arrival_city}
            cancellationDescription={data.cancellation_description}
            tripNote={data.trip_note}
          />
        )}
      </div>

      {/* Right Column - Booking Sidebar */}
      {/* <div className="ekv:lg:col-span-1"> */}
      {/* <PackageBooking packageId={data.id} startRatePax={8} /> */}
      {/* </div> */}
      {/* </div> */}
    </div>
  );
}
